var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{},[_c('echart',{attrs:{"chart-id":"camera-trap-devs","options":_vm.option,"not-merge":true,"height":160}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }